import React, {Component} from "react";
import {Form, Input, Modal} from "antd";
import PropTypes from 'prop-types';

import {formStandaloneLayout} from "../../../assets/styles";
import {messageType, showMessages} from "../../../helpers/message";
import {nothingToUpdate} from "../../../helpers/text";
import {sendLoginEmailVerification, updateUser} from "../../../helpers/user";

class LoginEdit extends Component {
    abortController = new AbortController();
    abortSignal = this.abortController.signal;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            newEmail: undefined,
        };
        this.formRef = React.createRef();
    }

    handleFinish = async () => {
        if (this.state.newEmail === undefined || (this.state.newEmail === this.props.email)) {
            showMessages(nothingToUpdate, messageType.error);
            return;
        }

        try {
            this.setState({isLoading: true});
            const requestData = {
                email: this.state.newEmail,
            };

            await updateUser(requestData, this.abortSignal);
            await sendLoginEmailVerification(false, this.abortSignal);
            showMessages('Login email address has been updated and a verification email has been sent to the member.', messageType.success);

            this.props.refreshLoginDetails();
            this.props.toggleEditState(false);

        } catch (error) {
            this.props.toggleEditState(false);
            showMessages(error.message, messageType.error);
        }
    };

    onEmailChange = (e) => {
        const email = e.target.value;

        this.formRef.current.setFieldsValue({
            'Email Address': email,
        })
        this.setState({newEmail: email});
    };

    render() {
        const {email, visible, toggleEditState} = this.props;
        const {isLoading} = this.state;
        const initialEmail = email || '';

        return <Modal
            title="Login Details"
            open={visible}
            confirmLoading={isLoading}
            okText="Save"
            onCancel={() => toggleEditState(false)}
            onOk={this.handleFinish}
        >
            <Form
                {...formStandaloneLayout}
                ref={this.formRef}
                id="login-edit"
                name="login-edit"
                onFinish={this.handleFinish}
                initialValues={{
                    'Email Address': initialEmail,
                }}
            >
                <Form.Item
                    name="Email Address"
                    label="Email Address"
                    trigger="onSubmit"
                    rules={[{required: true, type: 'email'}]}
                >
                    <Input
                        onChange={this.onEmailChange}
                        ref={input => input && input.focus()}
                    />
                </Form.Item>
            </Form>
        </Modal>
    }
}

LoginEdit.propTypes = {
    email: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    toggleEditState: PropTypes.func.isRequired,
    refreshLoginDetails: PropTypes.func.isRequired,
};

export default LoginEdit;
